import React from 'react'

function MessageManagement() {
  return (
    <div>MessageManagement</div>
  )
}

export default MessageManagement